import { SalesRequestTypeEnum } from "@/enums"
type RequestTypeInfo = {
  bgColor: string
  text: string
}
export const getRequestTypeInfo = (
  requestType: SalesRequestTypeEnum,
): RequestTypeInfo => {
  switch (requestType) {
    case SalesRequestTypeEnum.RECURRING:
      return {
        bgColor: "#4ade80",
        text: "Recorrente",
      }
    case SalesRequestTypeEnum.ROTARY:
      return {
        bgColor: "#60a5fa",
        text: "Rotativo",
      }
    default:
      return {
        bgColor: "#9ca3af",
        text: requestType,
      }
  }
}
